
import React from "react";
import { CalendarDays } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { intermediateTierSchema } from "@/contexts/program-creation/types";

interface CurrentRoutineSectionProps {
  form: UseFormReturn<z.infer<typeof intermediateTierSchema>>;
}

export default function CurrentRoutineSection({ form }: CurrentRoutineSectionProps) {
  return (
    <div className="space-y-5 mb-8">
      <div className="flex items-center gap-2 text-white/90 border-b border-white/20 pb-2">
        <CalendarDays size={18} />
        <h4 className="font-medium">Current Workout Routine</h4>
      </div>
      
      <FormField
        control={form.control}
        name="currentRoutine"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white/90 text-sm">
              Describe their current workout routine or activities (if any)
            </FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Push, Pull, Legs. Upper/Lower Split. Squat, Bench, Deadlift Focus. 3x weekly run, aerobic threshold, interval, long run" 
                className="bg-white/20 border-white/30 text-white min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
